export default __webpack_public_path__ + "static/media/SickKids.649955b3.jpg";